import { gql } from "@apollo/client";

export const ADD_ASSOCIATION_MUTATION = gql`
  mutation AddAssociation(
    $current_user: ID!
    $user_being_associated: ID!
    $association: Association!
  ) {
    addAssociation(
      current_user: $current_user
      user_being_associated: $user_being_associated
      association: $association
    ) {
      response
    }
  }
`;

export const MANAGE_ASSOCIATION_REQUEST = gql`
  mutation ManageAssociationRequest(
    $request_to: ID!
    $request_by: ID!
    $association: Association!
    $action: ASSOCIATION_REQUEST_ACTION!
  ) {
    manageAssociationRequest(
      request_to: $request_to
      request_by: $request_by
      association: $association
      action: $action
    )
  }
`;

export const GET_ASSOCIATION_REQUESTS = gql`
  query GetAssociationRequests($input: GetAssociationInput!) {
    getAssociationRequests(input: $input) {
      total_follow_requests
      total_patron_requests
      requests {
        request_id
        createdAt
        request_by {
          id
          name
          display_name
          first_name
          last_name
          profile_bio
          profile_picture {
            url
            type
          }
        }
        request_status
      }
    }
  }
`;

export const CHECK_FOLLOW = gql`
  query checkFollowerOrPatron($userId: ID!) {
    checkFollowerOrPatron(user_id: $userId) {
      follower
      patron
      follow_pending
      patron_pending
    }
  }
`;

export enum AssociationResponse {
  ACCEPTED = "ACCEPTED",
  REQUEST_SENT = "REQUEST_SENT",
  REMOVED = "REMOVED",
}

export enum ASSOCIATION_REQUEST_ACTION {
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
}

export interface AssociationResult {
  response: AssociationResponse;
}

export interface AssociationRequestAuthor {
  id: string;
  name: string;
  display_name?: string;
  first_name?: string;
  last_name?: string;
  profile_bio?: string;
  profile_picture?: {
    url: string;
    type: string;
  };
}

export interface AssociationRequest {
  request_id: string;
  createdAt: string;
  request_by: AssociationRequestAuthor;
  request_status: string;
}
